import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar as CalendarPicker } from "@/components/ui/calendar";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

export function ScheduleModal({ contact, onClose, scheduleDate, setScheduleDate, scheduleValue, setScheduleValue, onSubmit }) {
  return (
    <Dialog open={!!contact} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-xs">
        <DialogHeader>
          <DialogTitle className="text-zinc-100 text-base font-semibold">
            Agendar — {contact?.nome}
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-3">
          <div>
            <Label className="text-xs">Data</Label>
            <Popover>
              <PopoverTrigger asChild>
                <Button variant="outline" className="w-full justify-start h-8 text-xs text-zinc-300 hover:bg-zinc-800 border-zinc-700">
                  {scheduleDate ? format(scheduleDate, "dd/MM/yyyy", { locale: ptBR }) : "Selecione"}
                </Button>
              </PopoverTrigger>
              <PopoverContent className="w-auto p-0">
                <CalendarPicker mode="single" selected={scheduleDate} onSelect={setScheduleDate} locale={ptBR} />
              </PopoverContent>
            </Popover>
          </div>
          <div>
            <Label className="text-xs">Valor (R$)</Label>
            <Input
              data-testid="schedule-value-input"
              type="number"
              value={scheduleValue}
              onChange={(e) => setScheduleValue(e.target.value)}
              placeholder="150"
              className="h-8 text-xs"
            />
          </div>
          <Button
            type="submit"
            data-testid="schedule-submit-btn"
            disabled={!scheduleDate}
            className="w-full bg-amber-500 text-zinc-950 hover:bg-amber-600 h-8 text-xs font-semibold disabled:opacity-50"
          >
            Confirmar
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
